<div class="p-grid">
  <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-2 p-px-sm-2 p-px-md-2 p-px-lg-2 p-px-xl-2">
    <p-panel [collapsed]="true" [toggleable]="true">
      <ng-template pTemplate="header">
        <p class="p-m-0" style="color: #232c70">
          <b>Filtrar postulaciones</b> <small class="p-ml-2 p-text-light">Presiona en el ícono para mostrar más opciones</small>
        </p>
    </ng-template>
      <div class="p-grid p-jc-between">
        <div class="p-d-flex p-flex-column p-flex-md-row">
          <div class="p-d-flex p-flex-column p-mr-3 p-mb-2">
            <small class="p-pl-2">Tipo de curso</small>
            <p-dropdown [options]="tipoCursos" (onChange)="filtrarPostulaciones()" [(ngModel)]="filter.tipoCurso" placeholder="Mostrar todo"></p-dropdown>
          </div>
          <div class="p-d-flex p-flex-column p-mr-3 p-mb-2">
            <small class="p-pl-2">Modalidad</small>
            <p-dropdown [options]="modalidades" (onChange)="filtrarPostulaciones()" [(ngModel)]="filter.modalidad" placeholder="Mostrar todo"></p-dropdown>
          </div>
          <div class="p-d-flex p-flex-column p-mr-3 p-mb-2">
            <small class="p-pl-2">Estado</small>
            <p-dropdown [options]="estados" (onChange)="filtrarPostulaciones()" [(ngModel)]="filter.estado" placeholder="Mostrar todo"></p-dropdown>
          </div>
        </div>
  
          <div class="p-d-flex p-flex-column p-mr-3 p-mb-2">
            <small class="p-pl-2">Ordenar por</small>
            <p-dropdown [options]="ordenar" name="ordenar" (onChange)="ordenarPostulaciones($event.value)" label="label" value="value" placeholder="Últimas postulaciones"></p-dropdown>
          </div>
      </div>
  </p-panel>
  </div>


  <div *ngIf="!loading" class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-3 p-px-sm-3 p-px-md-3 p-px-lg-3 p-px-xl-3">
    
    <div *ngIf="!postulacionesFiltradas.length" class="p-grid postulacion-card">
      <div class="p-col-12 p-text-center">
        <h3>No hay postulaciones que mostrar.</h3>
      </div>
      
    </div>

      <!-- tarjeta postulacion -->
        <div class="p-grid postulacion-card" *ngFor="let postulacion of postulacionesFiltradas">
          <div class="p-col-12 p-lg-4">
            <div class="p-d-flex p-flex-column">
              <h3 class="p-m-0">{{postulacion.curso.nombre}}</h3>
              <div class="p-d-flex p-flex-inline-row p-mt-2 p-mb-4">
                <span class="p-mr-2 etiqueta" [ngClass]="'MODALIDAD-' + postulacion.curso.modalidad"><small>{{postulacion.curso.modalidad}}</small></span>
                <span class="etiqueta" [ngClass]="'ETIQUETA-' + postulacion.curso.tipoCurso"><small>{{postulacion.curso.tipoCurso}}</small></span>
              </div>
              <p class="p-m-0"><small>N° Postulación: #{{postulacion.postulacion_id}}</small><br><small>Versión: v{{postulacion.version}}</small></p>
            </div>
          </div>
          <div class="p-col-12 p-lg-5">
            <p class="p-m-0">
              <b>Fecha postulación:</b><br>
              <span style="font-size: 0.9rem">{{postulacion.fechaPostulacion | date: "d 'de' MMMM 'de' y 'a las' H:mm 'hrs.'" : 'UTC +0' : 'es' }}</span>
            </p>
          </div>
          <div class="p-col-12 p-lg-3" style="border-left: 1px solid #ddd;">
            <div class="p-d-flex p-flex-column">
              <p class="p-m-0">Estado</p>
              <h2 class="p-m-0">{{postulacion.estado}}</h2>
              <div class="p-d-flex p-flex-inline-row p-ai-center p-mt-2" [pTooltip]="this.getAyudaEstadoPostulacion(postulacion.estado)" tooltipPosition="bottom">
                <small class="p-mr-1">Más información</small>
                <i class="pi pi-info-circle"></i>
              </div>
            </div>
          </div>
        </div>
  
    
  </div>

  <div *ngIf="loading"  class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-3 p-px-sm-3 p-px-md-3 p-px-lg-3 p-px-xl-3">
    <div class="p-grid postulacion-card datagrid__row" *ngFor="let postulacion of [1,2,3]">
      <div class="p-col-12 p-lg-4">
        <div class="p-d-flex p-flex-column">
          <div class="p-mb-1"><p-skeleton width="100%" height="1.8rem"></p-skeleton></div>
          <div class="p-mb-4"><p-skeleton width="50%" height="1.4rem"></p-skeleton></div>
          <div><p-skeleton width="70%" height="1.2rem"></p-skeleton></div>
        </div>
      </div>
      <div class="p-col-12 p-lg-5">
        <div><p-skeleton width="100%" height="1.8rem"></p-skeleton></div>
      </div>
      <div class="p-col-12 p-lg-3" style="border-left: 1px solid #ddd;">
        <div class="p-d-flex p-flex-column">
          <div class="p-mb-1"><p-skeleton width="40%" height="1.5rem"></p-skeleton></div>
          <div class="p-mb-1"><p-skeleton width="100%" height="1.8rem"></p-skeleton></div>
          <div><small><p-skeleton width="80%" height="1.3rem"></p-skeleton></small></div>
        </div>
      </div>
    </div>
  </div>
</div>